import logo from './logo.svg';
import './App.css';
import CustomRoutes from './navigation/CustomRoutes'

function App() {
  return (
    <CustomRoutes />
  );
}

export default App;
